import React from 'react';
import { shape } from 'prop-types';
import { Card, Tabs } from 'antd';

import FroalaEditorView from 'Src/common/components/froalaEditor/froalaEditorView';
import './style.scss';

function Description({ programDetails }) {
  return (
    <div className="mt24 mentorship-description-wrapper">
      <Card>
        <Tabs>
          <Tabs.TabPane tab="Details" key="item-1">
            <If condition={programDetails.description}>
              <div className="mentorship-description-content">
                <FroalaEditorView model={programDetails.description} />
              </div>
            </If>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
}

Description.propTypes = {
  programDetails: shape().isRequired,
};

export default Description;
